import React from "react";
import { Gift } from "lucide-react";
import { BONUSES } from "../mock";

export default function Bonus() {
  const totalBonusValue = BONUSES.reduce((acc, b) => acc + parseFloat(b.value.replace(".", "").replace(" €", "")), 0);

  return (
    <section className="py-24 lg:py-36 bg-[#0c0c0c] border-y border-white/5">
      <div className="container-max">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <span className="section-label">5 Bonus inclusi</span>
            <h2 className="font-display text-4xl lg:text-6xl leading-[1] text-white mt-6 max-w-3xl">
              Cinque bonus.<br />
              <span className="italic font-light text-white/60">Valore reale.</span>
            </h2>
          </div>
          <div className="text-right">
            <div className="font-mono-label text-white/40 text-[11px]">Valore complessivo bonus</div>
            <div className="font-display text-4xl lg:text-5xl text-lime">€ 4.143+</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {BONUSES.map((b, i) => (
            <div
              key={b.id}
              className="bg-card border border-white/10 rounded-2xl p-6 hover-lift group flex flex-col"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-11 h-11 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center group-hover:bg-lime transition-colors">
                  <Gift size={18} className="text-white group-hover:text-black transition-colors" />
                </div>
                <div className="font-mono-label text-white/30 text-[10px]">{b.tag}</div>
              </div>
              <div className="font-display text-xl lg:text-2xl text-white">{b.name}</div>
              <p className="text-white/60 text-sm mt-3 leading-relaxed flex-1">{b.desc}</p>
              <div className="mt-5 pt-5 border-t border-white/10">
                <div className="font-mono-label text-white/40 text-[10px]">Valore</div>
                <div className="font-display text-xl text-white">{b.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
